
import { forwardRef } from 'react';
import * as Styles from './styles';
import { Spinner } from 'react-bootstrap';

export const ButtonAction = forwardRef( ({children, ...rest}, ref) => {
    const {disabled = false} =  rest;
    return(

        (
            <Styles.RedirectButton 
                {...rest}
                ref={ref}
            >
        
                {children}

                {
                    disabled && <Spinner animation="border" variant="primary" />
                }
            </Styles.RedirectButton>

        )
    )
})